import { Container, cssVar, getAvatarColor, Label, useAlignments, useSizes } from 'metrix-common3';
import styled from 'styled-components';

const AvatarContainer = styled(Container)`
	width: 23px;
	height: 23px;
`;

const AvatarComponent = styled(Container)`
	border-radius: 50%;
`;

const Avatar = (props) => {
    const alignments = useAlignments();
    const sizes = useSizes();

    return (
        <AvatarContainer>
            <AvatarComponent
                fullSize
                verticalAlignment={alignments.center}
                horizontalAlignment={alignments.center}
                color={props.color || getAvatarColor(`${props.firstName} ${props.lastName}`, 80, 40)}
            >
                <Label
                    size={sizes.sm}
                    textAlign={alignments.left}
                    text={`${props.firstName?.charAt(0) || ''}${props.lastName?.charAt(0)}` || ''}
                    color={cssVar.colorLightMode}
                />
            </AvatarComponent>
        </AvatarContainer>
    );
};

export default Avatar;
